/**
 * Reads a list-shaped translation key.
 *
 * i18next returns "" for an undefined key and the key itself when it fails to
 * resolve — neither is an array. Callers rendering a list would then crash on
 * .map(), so every list read goes through this guard and degrades to an empty
 * section instead.
 *
 * @param {(key: string, options?: object) => unknown} t - i18next translate function
 * @param {string} key - dotted key path pointing at an array in the locale file
 * @returns {Array<unknown>} the list, or [] when the key doesn't resolve to one
 */
export const getLocaleList = (t, key) => {
  const value = t(key, { returnObjects: true });
  return Array.isArray(value) ? value : [];
};
